import LocalStorage from './LocalStorage'
import Api from './Api'
import swaller from '../Library/Tools/Swaller'

class AuthService {
  // Logout manuale (con conferma)
  async logout (navigate) {
    const res = await swaller.question('Confermi di voler effettuare il Logout?')
    if (res) {
      this.performLogout(navigate)
    }
  }

  // Logout automatico (senza conferma, con messaggio personalizzato)
  async autoLogout (message = 'Sessione scaduta per inattività. Sarai reindirizzato al login.', navigate = null) {
    try {
      await swaller.warning(message)
      this.performLogout(navigate)
    } catch (error) {
      // Forza il logout anche in caso di errore
      this.performLogout(navigate)
    }
  }

  // Esegue il logout effettivo (pulizia dati + redirect)
  performLogout (navigate = null) {
    // Pulisce tutti i dati di sessione
    LocalStorage.clear()
    Api.setToken(null)

    // Reindirizza al login
    if (navigate && typeof navigate === 'function') {
      navigate('/login')
    } else {
      window.location.href = '/login'
    }
  }

  // Verifica se l'utente è loggato
  isLoggedIn () {
    const user = LocalStorage.get('user')
    return !!user
  }

  // Ottiene l'utente corrente
  getCurrentUser () {
    return LocalStorage.get('user')
  }
}

// Esporta un'istanza singleton
const authService = new AuthService()
export default authService
